import React, { Component } from 'react';
import HomeLocationMarkerView from './home-location-marker-view';
import { connect } from 'react-redux';
import { setCurrentDriverCardOnMap } from '../available-drivers-map/available-drivers-map-actions';

class HomeLocationMarker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    }
  }

  mouseEnter = () => this.setState({hovered: true});
  mouseLeave = () => this.setState({hovered: false});

  render() {
    return (
      <HomeLocationMarkerView
        {...this.props}
        mouseEnter={this.mouseEnter}
        mouseLeave={this.mouseLeave}
        hovered={this.state.hovered}
        expanded={this.props.availableDriversMap.currentDriver && this.props.availableDriversMap.currentDriver.driverId === this.props.driver.driverId}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  availableDriversMap: state.availableDriversMap
});

const mapDispatchToProps = {
  setCurrentDriverCardOnMap: setCurrentDriverCardOnMap
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeLocationMarker);



// WEBPACK FOOTER //
// ./src/components/map-markers/home-location-marker.js